import React, { Component, Fragment } from 'react'
import { NavLink,Link } from 'react-router-dom'

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      isOpen: false,
    }
  }

  onClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  close = () => {
    if(this.state.isOpen){
      this.setState({
        isOpen: false
      })
    }
  }

  timeOfDay = () => {
    if(this.hourOfDay < 12){
      return "Good Morning"
    } else if(this.hourOfDay >= 12 && this.hourOfDay < 17){
      return "Good Afternoon"
    } else if(this.hourOfDay >= 17 && this.hourOfDay < 22){
      return "Good Evening"
    } else if(this.hourOfDay >= 22 && this.hourOfDay <= 23){
      return "Working late?"
    } else {
      return "Hello"
    }
  }

  instructions = () => {
    window.open(`https://vimeo.com/776244220`)
  }

  render() {
    return (
      <div className="row border-bottom white-bg">
        <nav className="navbar navbar-static-top">
          <div className="navbar-header">
            <button aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse" type="button" className="navbar-toggle collapsed" onClick={this.onClick}>
              <i className="fa fa-reorder"></i>
            </button>
            <Link to="/list" className="navbar-brand" onClick={this.close}>ECL</Link>
          </div>
          <div id="navbar" className={`navbar-collapse collapse ${this.state.isOpen ? "in":""}`}>
            <ul className="nav navbar-nav">
              <li onClick={this.close}><NavLink exact to="/list" activeClassName="active">Orders</NavLink></li> 
              <li onClick={this.close}><a href="" onClick={this.instructions}>NAB Collection Instructions</a></li>                      
            </ul>
            <ul className="nav navbar-nav navbar-right">
              <li><span className="m-r-sm text-muted welcome-message">{ `${this.timeOfDay()} ${this.props.user.firstName}`}</span></li>
              <li><a href="/sign-out"><i className="fa fa-sign-out"></i>Log out</a></li>
            </ul>
          </div>
        </nav>
      </div>
    )
  }
}

export default Header
